/// <reference path="references.ts"/>
var main = {
    init: function () {
        main.initMobileNav();
        main.attachCourseTab();
        main.initHeaderScroll();
        main.initHeaderSearch();
        main.initHeaderPredictiveSearch();
        main.initVideoMagnificPopup();
        main.attachAttendeesCost();
        main.registraionFormAttendeesCost();
        if ($('body').hasClass('page-312168')) {
            main.initHomeCarousel();
            // main.initHomeMobileCarousel();
            main.initClientsCarousel();
        }
        main.initGallery();
        main.initTopbarFilter();
        main.initZebraAccordions();
        main.attachClickEventForAccordionItems();
        main.attachClickEventForLargeAccordionItems();
        if ($('body').hasClass('page-280638')) {
            main.productsPageHashLinks();
        }
        main.whitePapers();
        main.windowHashScroll();
        main.displayFormsTnC();
        main.timeCountdown();
        main.setRegisterBtnEvent();
        main.initAgenda();
    },
    initAgenda: function () {
        $('.agenda__table-date-switcher a').on('click', function (e) {
            e.preventDefault();
            main.selectAgendaDay($(this).data('target'));
        });
        main.selectAgendaDay('mon');
        console.log($('.agenda__table-day-show').html());
        //Set initial day to show on page load.
        $('.agenda__table-title-show').addClass('active');
        $('.agenda__table-day-show').show();
    },
    selectAgendaDay: function (day) {
        $('.agenda__table-date-switcher a').removeClass('active');
        $('.agenda__table-date-switcher a[data-target="' + day + '"]').addClass('active');
        $('.agenda__table-day').hide();
        $('.agenda__table-day.' + day).show();
    },
    setRegisterBtnEvent: function () {
        $("#registerbtn").click(function () {
            main.scrollToElement($("#buttom_of_page"));
            //  $("html, body").animate({ scrollTop: $(document).height() }, 1000);
        });
    },
    timeCountdown: function () {
        $(".countdown-timer").each(function () {
            $(this).countdown("2019/03/18", function (event) {
                $(this).find(".days .time").text(event.strftime('%D'));
                $(this).find(".hours .time").text(event.strftime('%H'));
                $(this).find(".minutes .time").text(event.strftime('%M'));
                $(this).find(".seconds .time").text(event.strftime('%S'));
            });
        });
    },
    whitePapers: function () {
        $('#country-select').on("change", function () {
            main.displayFormsTnC();
        });
        $('#country-select').on('change', function () {
            $('select[name="state"]').toggle($(this).val() == 'Australia');
        });
    },
    displayFormsTnC: function () {
        if ($('#country-select').find("option:selected").attr("data-europe") == "true") {
            $('#marketing-checkbox-container').removeClass("hidden").find("input").removeAttr("checked");
        }
        else {
            $('#marketing-checkbox-container').addClass("hidden").find("input").attr("checked", "checked");
        }
    },
    productsPageHashLinks: function () {
        if (window.location.hash != "") {
            $(window.location.hash).click();
        }
    },
    initTopbarFilter: function () {
        if ($('.select__filter').length) {
            $('.select__filter').on('change', function (e) {
                e.preventDefault();
                $(this).closest('form').submit();
            });
        }
        if ($('.form__filter--clear').length) {
            $('.form__filter--clear').on('click', function (e) {
                if (!$(this).closest("body").hasClass('template-solutions')) {
                    e.preventDefault();
                }
                $('.select__filter').val('');
                $(this).closest('form').submit();
            });
        }
        $('a').on("click", function (e) {
            main.windowHashScroll();
        });
    },
    windowHashScroll: function () {
        if (window.location.hash != "") {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top - $('.header__container--scroll').height() + "px"
                }, 0);
            }, 50);
        }
    },
    initHomeCarousel: function () {
        if ($('.header__slider').length) {
            $('.header__slider').owlCarousel({
                autoplay: true,
                autoplaySpeed: 250,
                loop: true,
                items: 1,
                nav: false,
                dots: true
            });
        }
    },
    initHomeMobileCarousel: function () {
        if ($('.home-mobile-carousel').length) {
            $('.home-mobile-carousel').owlCarousel({
                autoplay: true,
                autoplaySpeed: 250,
                loop: true,
                items: 1,
                nav: false,
                dots: true
            });
        }
    },
    initClientsCarousel: function () {
        $('.clients__slider').owlCarousel({
            loop: true,
            items: 1,
            autoplay: true,
            autoplaySpeed: 250,
            nav: true,
            center: true,
            margin: 20,
            responsive: {
                768: {
                    items: 2,
                    center: false,
                    autoplay: true,
                },
                1025: {
                    items: 3,
                    center: false,
                    autoplay: false,
                }
            }
        });
    },
    initGallery: function () {
        if ($('.gallery__slider').length) {
            $('.gallery__slider').owlCarousel({
                loop: true,
                items: 1,
                autoplay: true,
                autoplaySpeed: 250,
                nav: false,
                center: false,
                responsive: {
                    768: {
                        items: 2,
                        nav: false,
                        center: false,
                        autoplay: true,
                        margin: 20
                    },
                    1025: {
                        items: 3,
                        nav: true,
                        center: false,
                        autoplay: false,
                        margin: 20
                    }
                }
            });
        }
        if ($('.image__gallery').length) {
            $('.image__gallery').magnificPopup({
                delegate: 'a.gallery__item',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        }
    },
    initMobileNav: function () {
        if ($('.header__burger').length) {
            $('.header__burger').on('click', function (e) {
                e.preventDefault();
                $(this).addClass('active');
                $('.mobile-menu').addClass('active');
                $('.mobile-menu-shadow').addClass('active');
                $('body').addClass('blocked');
            });
            $('.mobile-menu__subtitle').on('click', function (e) {
                e.preventDefault();
                $(this).toggleClass('opened');
                $(this).next('.mobile-menu__submenu').toggleClass('opened');
            });
            // Close mobile menu
            $('#mobile-menu-close, #mobile-menu-shadow').on('click', function (e) {
                e.preventDefault();
                $('.header__burger').removeClass('active');
                $('.mobile-menu').removeClass('active');
                $('.mobile-menu-shadow').removeClass('active');
                $('body').removeClass('blocked');
            });
        }
    },
    /**
     * Any Anchors hashtags and classed with scroll-to will animate the scrolling
     * to the specified element on the page.
     */
    initScrollToLinks: function () {
        var links = $('a.scroll-to[href^=#]:not([href=#])');
        if (!links.length) {
            return false;
        }
        links.click(function () {
            var target = $(this.hash).first();
            if (!target.length) {
                return false;
            }
            main.scrollToElement(target);
        });
    },
    initZebraAccordions: function () {
        var zebra = new $.Zebra_Accordion($('.Zebra_Accordion'), {
            collapsible: true,
            hide_speed: 200,
            show_speed: 200,
            show: false
        });
    },
    attachClickEventForAccordionItems: function () {
        $('.accordion__link').on('click', function (e) {
            e.preventDefault();
            //get the source image
            var expanded = $(this).parent('dt').hasClass("Zebra_Accordion_Expanded");
            if (expanded) {
                $(this).find('img').removeClass('open');
            }
            else {
                $(this).find('img').addClass('open');
            }
        });
    },
    attachClickEventForLargeAccordionItems: function () {
        $('.accordion-large__link').on('click', function (e) {
            e.preventDefault();
            // //get the source image
            var expanded = $(this).parent('dt').hasClass("Zebra_Accordion_Expanded");
            // SVG cannot have a class added / removed. Use attr.
            if (expanded) {
                $(this).find('svg').attr('class', 'accordion-large__arrow');
            }
            else {
                $(this).find('svg').attr('class', 'accordion-large__arrow open');
            }
        });
    },
    attachCourseTab: function () {
        if (!$('.course-tab').length) {
            return false;
        }
        $('.course-tab').on('click', function (e) {
            if (!$(this).hasClass('active')) {
                $('.course-tab').removeClass('active');
                $(this).addClass('active');
                if ('onsite' == $(this).data('tab')) {
                    $('.course-detail__form--onsite').addClass('active');
                    $('.course-detail__form--public').removeClass('active');
                }
                else {
                    $('.course-detail__form--onsite').removeClass('active');
                    $('.course-detail__form--public').addClass('active');
                }
            }
        });
    },
    attachAttendeesCost: function () {
        var $_attendees_input = $('#course-detail__form--tickets');
        var $_ticket_base_price = $('#course-select');
        // var $_ticket_tax = $('#ticket_tax');
        var $_ticket_total_price = $('#ticket_total_price');
        var attendees_input = $_attendees_input.val();
        var ticket_base_price = "";
        // var ticket_tax = $_ticket_tax.val();
        var ticket_tax = 0.1;
        var ticket_total_price = $_ticket_total_price.val();
        $_ticket_base_price.on('change', function (e) {
            ticket_base_price = $_ticket_base_price.find("option:selected").data("cost");
            $('#ticket_base_price_label').text(ticket_base_price);
            $('#ticket_amount').val(ticket_base_price);
            $_attendees_input.val(attendees_input);
            $('input[name="event_data"]').val($_ticket_base_price.find("option:selected").data("event-data"));
        });
        if ($_attendees_input.length) {
            $_attendees_input.on('change', function (e) {
                if (ticket_base_price != "") {
                    e.preventDefault();
                    var multiplier = $(this).val();
                    if (multiplier <= 0) {
                        multiplier = 1;
                    }
                    var tax_result = ((ticket_tax * parseFloat(ticket_base_price)) * parseFloat(multiplier)).toFixed(2);
                    var tax_result_formatted = main.formatPrice(tax_result);
                    var base_price_result = ((parseFloat(ticket_base_price) * parseFloat(multiplier)) - parseFloat(tax_result)).toFixed(2);
                    var base_price_formatted = main.formatPrice(base_price_result);
                    var total_price_result = (parseFloat(ticket_base_price) * parseFloat(multiplier)).toFixed(2);
                    var total_price_formatted = main.formatPrice(total_price_result);
                    $('#ticket_base_price_label').text(base_price_formatted);
                    $('#ticket_tax_label').text(tax_result_formatted);
                    $('#ticket_total_price_label').text(total_price_formatted);
                }
            });
        }
    },
    registraionFormAttendeesCost: function () {
        if ($('body').hasClass("template-course-register")) {
            var $_attendees_input = $('#course-register__ticket-quantity');
            var attendees = $_attendees_input.val();
            var $_package = $('select#package-select');
            var price = main.packagePrice($_package, attendees);
            $(document).on("change", $_attendees_input, function () {
                attendees = $_attendees_input.val();
                price = main.packagePrice($_package, attendees);
            });
            $(document).on("change", $_package, function () {
                price = main.packagePrice($_package, attendees);
            });
            var $_package_base_price = $('#ticket_base_price');
            var $_package_tax = $('#ticket_tax');
            var $_package_total_price = $('#ticket_total_price');
            $(document).on("change", 'input[placeholder="First Name*"], input[placeholder="Last Name*"]', function () {
                var text = $(this).closest('.attendee-content').find($('input[placeholder="First Name*"]')).val() + " " + $(this).closest('.attendee-content').find($('input[placeholder="Last Name*"]')).val();
                var target = $(this).closest(".attendee-list-item").index() + 1;
                $(".attendee-number-" + target).find(".course-attendee__label--name").html("- " + text);
            });
        }
    },
    packagePrice: function ($_package, attendees) {
        var $_selected_package = $_package.find("option:selected");
        var tax = $_selected_package.data("tax");
        var basePrice = $_selected_package.data("price");
        var midPrice = $_selected_package.data("mid_price");
        var bulkPrice = $_selected_package.data("bulk_price");
        var price;
        if (attendees < 3) {
            price = basePrice;
        }
        else if (attendees == 3 || attendees == 4) {
            price = midPrice;
        }
        else if (attendees > 4) {
            price = bulkPrice;
        }
        $('#ticket_base_price_label').html(main.formatPrice(price));
        $('#ticket_tax_label').html(main.formatPrice(price * tax));
        $('#ticket_total_price_label').html(main.formatPrice(price * attendees));
        return price;
    },
    initHeaderScroll: function () {
        if (!$('.header__container--scroll').length) {
            return false;
        }
        $(window).scroll(function (event) {
            var scroll_height = $(window).scrollTop();
            if (scroll_height > 50) {
                if (!$('.header__container--scroll').hasClass('detached')) {
                    $('.header__container--scroll').addClass('detached');
                }
            }
            else {
                $('.header__container--scroll').removeClass('detached');
            }
        });
    },
    /**
     * Setup events for open/closing the header search
     * and clearing the search input.
     */
    initHeaderSearch: function () {
        var search_form = $('#header__search');
        var search_close = $('#search-icon-close');
        var search_button = $('#header_search_btn');
        var search_input = $('.header__search-input');
        var autocomplete = $('.autocomplete-suggestions');
        // Search button click event. Open search input area
        search_button.click(function (e) {
            e.preventDefault();
            search_form.addClass('open');
            search_input.focus();
        });
        search_button.mouseup(function () {
            return false;
        });
        // Clicking anywhere when the search is open will close search
        search_input.on('blur', function () {
            main.searchClear();
        });
        search_close.on('click', function () {
            main.searchClear();
        });
    },
    searchClear: function () {
        var search_form = $('#header__search');
        var search_input = $('.header__search-input');
        var autocomplete = $('.autocomplete-suggestions');
        if (search_form.hasClass('open')) {
            search_form.removeClass('open');
            // Need to give the element time to finish the closing
            // animation to run this reset code.
            setTimeout(function () {
                search_input.val('');
                autocomplete.hide();
            }, 500);
        }
    },
    initHeaderPredictiveSearch: function () {
        var input = $('.header__search-input').first();
        if (!input.length) {
            return false;
        }
        // jQuery AutoComplete
        input.autocomplete({
            minChars: 3,
            maxHeight: false,
            serviceUrl: '/asearch',
            formatResult: function (suggestion, current_value) {
                // Format the search results by including a title and context summary.
                var regex = new RegExp(current_value, 'gi'); // Search for keyword
                var replacement = '<strong>$&</strong>'; // Wrap the matched string in tags
                // Find keywords and wrap them in tags
                var title_highlighted = suggestion.data.title.replace(regex, replacement);
                var summary_highlighted = suggestion.data.summary.replace(regex, replacement);
                // Create title element
                var title_elem = $('<span class="autocomplete-suggestion__title"></span>');
                title_elem.html(title_highlighted);
                // Create summary element
                var summary_elem = $('<span class="autocomplete-suggestion__summary"></span>');
                if (summary_highlighted) {
                    summary_elem.html('... ' + summary_highlighted + ' ...');
                }
                var tmp = $('<div></div>').append(title_elem, summary_elem);
                return tmp.html();
            },
            onSelect: function (suggestion) {
                // On select of a suggestion, we'll navigate directly to the page
                if (suggestion.data.pageurl) {
                    window.location.href = suggestion.data.pageurl;
                }
            },
        });
    },
    /*
     * Initialiser function to bind each video to opening a magnific popup
     */
    initVideoMagnificPopup: function () {
        var elements = $('.magnific__video');
        if (!elements.length) {
            return false;
        }
        $(elements).each(function () {
            if ($(this).length) {
                main.initMagnificOptions($(this));
            }
        });
    },
    /* Handles the set up of magnific with custom markup for iframes
     * and navigation arrows
     * Magnific only allows navigation of gallery images, not iframe
     * we had to code this custom code.
     */
    initMagnificOptions: function (element) {
        element.magnificPopup({
            type: 'iframe',
            midClick: true,
            key: 'banner-video',
            removeDelay: 500,
            mainClass: 'mfp-fade',
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: function (url) {
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                            if (!m || !m[1])
                                return null;
                            return m[1];
                        },
                        src: '//www.youtube.com/embed/%id%?rel=0&ytp-pause-overlay=0'
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: function (url) {
                            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                            if (!m || !m[5])
                                return null;
                            return m[5];
                        },
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                    }
                }
            }
        });
    },
    /**
     * Scroll to specified DOM element
     * @param  Element element DOM or jQuery Element
     */
    scrollToElement: function (element) {
        if (!(element instanceof jQuery)) {
            element = jQuery(element);
        }
        $('html, body').animate({
            scrollTop: element.offset().top
        });
    },
    // Referenced from stackoverflow on 6/6/2018
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    numberWithCommas: function (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatPrice: function (number) {
        return '$' + main.numberWithCommas(number);
    }
};
